//----------------------
// calc current ability
//----------------------
export default function calcCurrentAbility(parm = {}, min = null, max = null) {
  // read core inputs from single parm object
  const base = Number(parm.base) || 0
  const adjs_tot = Number(parm.adjs_tot) || 0

  // allow min/max to be provided as the 2nd/3rd args OR as properties on parm
  const minVal = (min !== null && min !== undefined) ? min : (parm.min !== undefined ? parm.min : null)
  const maxVal = (max !== null && max !== undefined) ? max : (parm.max !== undefined ? parm.max : null)

  let result = base + adjs_tot

  // preserve existing behavior: return null for a total of 0 (change if 0 should be valid)
  if (result === 0) return null

  if (minVal !== null && result < minVal) return minVal
  if (maxVal !== null && result > maxVal) return maxVal

  return result
}
